import { Box, Button, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";

interface Props {
    onReset: () => void;
}

export default function FiltersContainer({ children, onReset }: PropsWithChildren<Props>) {
    const theme = useTheme();

    return (
        <Box
            display={"flex"}
            alignItems={"stretch"}
            border={`1px solid ${theme.palette.divider}`}
            borderRadius={1}
            mb={2}
        >
            <Box p={2} flexGrow={1} gap={2} display={"flex"} alignItems={"center"} flexWrap={"wrap"}>
                {children}
            </Box>
            <Button
                variant={"contained"}
                sx={{
                    writingMode: "vertical-lr",
                    textOrientation: "mixed",
                    borderBottomLeftRadius: 0,
                    borderTopLeftRadius: 0,
                    minWidth: 42,
                }}
                size={"small"}
                onClick={onReset}
            >
                Reset
            </Button>
        </Box>
    );
}
